// Check if value is not undefined
/**
 * @deprecated - use `checkIsDefined` in src/features/Common/modules/DataTypes/utils/nanNullUndef.ts
 */
export function isDefined<T = any>(p: T): p is NonNullable<T> {
    return typeof p !== "undefined";
}
